import React from "react";
import UserLogin from "../../Auth/UserLogin";
import ResetPassword from "../../Auth/ResetPassword";
import Dashboard from "../Pages/Dashboard/Dashboard";
import Employees from "../Pages/StaffManagement/AllEmployees/Employees";
import CreateEmployee from "../Pages/StaffManagement/CreateEmployee/CreateEmployee";
import DashboardIcon from "../../../Asssets/Images/DashboardIcon.svg";
import ProfileIcon from "../../../Asssets/Images/ProfileIcon.svg";
import TimeSheetIcon from "../../../Asssets/Images/timesheetIcon.svg";
import StaffIcon from "../../../Asssets/Images/Staff.svg";
import AttendanceIcon from "../../../Asssets/Images/AttendanceIcon.svg";
import AnnouncementIcon from "../../../Asssets/Images/AnnouncementIcon.svg";
import PurchaseRequisitionsIcon from "../../../Asssets/Images/PurchaseRequisitions.svg";
import RequestModuleIcon from "../../../Asssets/Images/RequestModule.svg";
import LoanRequestIcon from "../../../Asssets/Images/LoanRequestIcon.svg";
import PettyPurchasesIcon from "../../../Asssets/Images/PettyPurchases.svg";
import PayrollIcon from "../../../Asssets/Images/payrollIcon.svg";
import LeaveManagementIcon from "../../../Asssets/Images/LeaveManagementIcon.svg";
import TicketsIcon from "../../../Asssets/Images/TicketsIcon.svg";
import PolicyIcon from "../../../Asssets/Images/Policy.png";
import SetupIcon from "../../../Asssets/Images/Setup.svg";
import Attendance from "../Pages/Attendance/Attendance";
import Announcement from "../Pages/Announcement/Announcement";
import Payroll from "../Pages/Payroll/Payroll";
import LeaveManagement from "../Pages/LeaveManagement/LeaveManagement";
import Ticket from "../Pages/Ticket/Ticket";
import CompanyPolicies from "../Pages/CompanyPolicies/CompanyPolicies";
import HRMSetup from "../Pages/HRMSetup/HRMSetup";
import EmployeeDetails from "../Pages/StaffManagement/EmployeeDetails/EmployeeDetails";
import TimeSheet from "../Pages/TimeSheet/TimeSheet";
import EditEmployee from "../Pages/StaffManagement/EditEmployee/EditEmployee";
import LeaveDetails from "../Pages/LeaveManagement/LeaveDetails";
import TicketDetails from "../Pages/Ticket/TicketDetails";
import Profile from "../../Employee/Pages/Profile/Profile";
import PayrollUpdate from "../Pages/Payroll/PayrollUpdate";
import PayrollDetails from "../Pages/Payroll/payrollDetails";
import Payslip from "../Pages/Payroll/Payslip/Payslip";
import TaxManagement from "../Pages/Payroll/TaxManagement/TaxManagement";
import Requests from "../Pages/RequestModule/Requests";
import RequestDetails from "../Pages/RequestModule/RequestDetails";
import LoanRequests from "../Pages/LoanRequestModule/LoanRequests";
import LoanRequestDetails from "../Pages/LoanRequestModule/LoanRequestDetails";
import WorkFromHome from "../Pages/WorkFromHome";
import PurchaseRequisitions from "../Pages/PurchaseRequisitions/PurchaseRequisitions";
import PurchaseRequisitionDetails from "../Pages/PurchaseRequisitions/PurchaseRequisitionDetails";
import PettyPurchases from "../Pages/PettyPurchases/PettyPurchases";
import PettyPurchaseDetails from "../Pages/PettyPurchases/PettyPurchaseDetails";
import ProtectedRoute from "../../../Components/ProtectedRoute/ProtectedRoute";

// HR Routes

export const userRoutes = [
  {
    path: "/",
    component: <UserLogin />,
  },
  {
    path: "/reset-password/:resettoken",
    component: <ResetPassword />,
  },
];

export const hrRoutes = [
  {
    path: "/HR/dashboard",
    component: <Dashboard />,
  },
  {
    path: "/HR/profile",
    component: <Profile />,
  },
  {
    path: "/HR/employees",
    component: <Employees />,
  },
  {
    path: "/HR/employees/create",
    component: <CreateEmployee />,
  },
  {
    path: "/HR/employee/:id",
    component: <EmployeeDetails />,
  },
  {
    path: "/HR/edit-employee/:id",
    component: <EditEmployee />,
  },
  {
    path: "/HR/attendance",
    component: <Attendance />,
  },
  {
    path: "/HR/announcement",
    component: <Announcement />,
  },
  {
    path: "/HR/payroll",
    component: <Payroll />,
  },
  {
    path: "/HR/payroll/:id",
    component: <PayrollDetails />,
  },
  {
    path: "/HR/payroll/payslip/:id",
    component: <Payslip />,
  },
  {
    path: "/HR/payroll/update/:id",
    component: <PayrollUpdate />,
  },
  {
    path: "/HR/payroll/tax-management",
    component: <TaxManagement />,
  },
  {
    path: "/HR/leave-management",
    component: <LeaveManagement />,
  },
  {
    path: "/HR/leave-management/:id",
    component: <LeaveDetails />,
  },
  {
    path: "/HR/tickets",
    component: <Ticket />,
  },
  {
    path: "/HR/tickets/:id",
    component: <TicketDetails />,
  },
  // {
  //   path: "/HR/company-policies",
  //   component: <CompanyPolicies />,
  // },
  {
    path: "/HR/hrm-setup",
    component: <HRMSetup />,
  },
  {
    path: "/HR/timesheet",
    component: <TimeSheet />,
  },
  {
    path: "/HR/requests",
    component: <Requests />,
  },
  {
    path: "/HR/request/:id",
    component: <RequestDetails />,
  },
  {
    path: "/HR/loan-requests",
    component: <LoanRequests />,
  },
  {
    path: "/HR/loan-request/:id",
    component: <LoanRequestDetails />,
  },
  {
    path: "/HR/wfh",
    component: <WorkFromHome />,
  },
  {
    path: "/HR/purchase-requisitions",
    component: (
      <ProtectedRoute
        allowedDepartments={[
          "68875ce1f9c0eda4dcce9c74",
          "6392e6b4758449db0ae81600",
          "63d8c6158c662fd4d455ce85",
        ]}
        allowedRoles={["HR", "admin"]}
      >
        <PurchaseRequisitions />
      </ProtectedRoute>
    ),
  },
  {
    path: "/HR/purchase-requisition/:id",
    component: (
      <ProtectedRoute
        allowedDepartments={[
          "68875ce1f9c0eda4dcce9c74",
          "6392e6b4758449db0ae81600",
          "63d8c6158c662fd4d455ce85",
        ]}
        allowedRoles={["HR", "admin"]}
      >
        <PurchaseRequisitionDetails />
      </ProtectedRoute>
    ),
  },
  {
    path: "/HR/petty-purchases",
    component: (
      <ProtectedRoute
        allowedDepartments={[
          "6392e6b4758449db0ae81600",
          "63d8c6158c662fd4d455ce85",
        ]}
        allowedRoles={["HR", "admin"]}
      >
        <PettyPurchases />
      </ProtectedRoute>
    ),
  },
  {
    path: "/HR/petty-purchases/:id",
    component: (
      <ProtectedRoute
        allowedDepartments={[
          "6392e6b4758449db0ae81600",
          "63d8c6158c662fd4d455ce85",
        ]}
        allowedRoles={["HR", "admin"]}
      >
        <PettyPurchaseDetails />
      </ProtectedRoute>
    ),
  },
];

export const HrSideBarItems = [
  {
    path: "/HR/dashboard",
    icon: <DashboardIcon />,
    title: "Dashboard",
    isSubNav: false,
  },
  {
    path: "/HR/profile",
    icon: <ProfileIcon />,
    title: "Profile",
    isSubNav: false,
  },
  {
    path: `${"/HR/employees/create" && "/HR/employees"}`,
    icon: <StaffIcon />,
    title: "Staff Management",
    isSubNav: false,
  },
  {
    path: "/HR/attendance",
    icon: <AttendanceIcon />,
    title: "Attendance",
    isSubNav: false,
  },
  {
    path: "/HR/requests",
    icon: <RequestModuleIcon />,
    title: "Request Module",
    isSubNav: false,
  },
  {
    path: "/HR/loan-requests",
    icon: <LoanRequestIcon />,
    title: "Loan Requests",
    isSubNav: false,
  },
  // Purchase Requisitions - Only visible to Accounts and Admin departments
  {
    path: "/HR/purchase-requisitions",
    icon: <PurchaseRequisitionsIcon />,
    title: "Purchase Requisitions",
    isSubNav: false,
    restricted: true,
    allowedDepartments: [
      "6392e6b4758449db0ae81600",
      "63d8c6158c662fd4d455ce85",
    ],
  },
  {
    path: "/HR/petty-purchases",
    icon: <PettyPurchasesIcon />,
    title: "Petty Purchases",
    isSubNav: false,
    restricted: true,
    allowedDepartments: [
      "6392e6b4758449db0ae81600",
      "63d8c6158c662fd4d455ce85",
    ],
  },
  {
    path: "/HR/timesheet",
    icon: <TimeSheetIcon />,
    title: "Time Sheet",
    isSubNav: false,
  },
  {
    path: "/HR/announcement",
    icon: <AnnouncementIcon />,
    title: "Announcement",
    isSubNav: false,
  },
  {
    path: "/HR/payroll",
    icon: <PayrollIcon />,
    title: "Payroll",
    isSubNav: false,
  },
  {
    path: "/HR/leave-management",
    icon: <LeaveManagementIcon />,
    title: "Leave Management",
    isSubNav: false,
  },
  {
    path: "/HR/tickets",
    icon: <TicketsIcon />,
    title: "Tickets",
    isSubNav: false,
  },
  // {
  //   path: "/HR/company-policies",
  //   icon: <PolicyIcon />,
  //   title: "Company Policies",
  //   isSubNav: false,
  // },
  {
    path: "/HR/hrm-setup",
    icon: <SetupIcon />,
    title: "HRM Setup",
    isSubNav: false,
  },
];
